import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    imports: [CommonModule],
})
export class PaginationComponent implements OnInit {
    @Output() pageChanged = new EventEmitter<number>();
    @Input() total: number;
    @Input() perPage: number = 12;
    @Input() page: number = 1;
    pages: number[] = [];

    constructor() {}

    ngOnInit() {
        const pages = Math.ceil(this.total / this.perPage);
        for (let page = 1; page <= pages; page++) {
            this.pages.push(page);
        }
    }

    changePage(page: number) {
        if (page === this.page) {
            return;
        }
        this.page = page;
        this.pageChanged.emit(page);
    }
}
